import { Badge, Card, Grid, Group, Stack, Text, Title } from "@repo/ui/core";
import type { AgendaSection } from "@data/types";
import { motion } from "framer-motion";
import classes from "@styles/onsite.module.css";

const SECTION_COLORS = ["emerald", "blue", "violet", "orange"] as const;
const SECTION_ACCENT_CLASSES = [
  classes.cardAccentGreen,
  classes.cardAccentBlue,
  classes.cardAccentViolet,
  classes.cardAccentOrange,
] as const;

type Props = {
  sections: AgendaSection[];
};

export function AgendaGrid({ sections }: Props) {
  return (
    <Grid gutter="xl">
      {sections.map((section, i) => (
        <Grid.Col key={section.number} span={{ base: 12, sm: 6, md: 3 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: i * 0.1 }}
            style={{ height: "100%" }}
          >
            <Card
              padding="xl"
              radius="md"
              h="100%"
              className={`${classes.cardSurface} ${SECTION_ACCENT_CLASSES[i % SECTION_ACCENT_CLASSES.length]}`}
            >
              <Stack gap="md">
                <Group justify="space-between" align="center">
                  <Text
                    size="48px"
                    fw={900}
                    c={`${SECTION_COLORS[i % SECTION_COLORS.length]}.4`}
                  >
                    {section.number}
                  </Text>
                  <Badge
                    variant="light"
                    size="lg"
                    color={SECTION_COLORS[i % SECTION_COLORS.length]}
                  >
                    {section.duration}
                  </Badge>
                </Group>
                <Title order={3} tt="uppercase" style={{ letterSpacing: "0.04em" }}>
                  {section.title}
                </Title>
              </Stack>
            </Card>
          </motion.div>
        </Grid.Col>
      ))}
    </Grid>
  );
}
